


window.addEventListener("load", (event) => {
  // Get the header element
const header = document.querySelector('.custom_main_header_group');

// Add a scroll event listener to the window
window.addEventListener('scroll', () => {
    if (window.scrollY > 0) {
        header.classList.add('header-scrolled');
    } else {
        header.classList.remove('header-scrolled');
    }
});
});